import Vue from "vue"

export default Vue.extend({
  props: {
    label: { type: String, default: "" },
    error: { type: String, default: "" },
    help: { type: [String, Object], default: "" },
  },
})
